import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UsersService } from '@app/core/access-control/services/users/users.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.sass'],
})
export class EmailConfirmationComponent {
  confirmEmail: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });
  check = false;

  constructor(
    private fb: FormBuilder,
    private userService: UsersService,
    private dialogRef: MatDialogRef<EmailConfirmationComponent>,
    private toastr: ToastrService
  ) {}

  confirm(data: { email: string }): void {
    this.userService.confirmEmailToResetPassword(data).subscribe({
      next: (response: any) => {
        this.check = response.success;
        if (this.check) {
          setTimeout(() => this.dialogRef.close(), 7000);
        }
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error(`Error: ${err?.error}`);
      },
    });
  }
}
